

const redRes2=(state={},action)=>{
    switch(action.type)
    {
        case 'response2':
            if(action.payload != undefined){
                return action.payload;
            }
            else{
                return null
            }

        default:
            return state
    }
}
export default redRes2